import DEOverview from '@/components/DE/DigitalExperience.vue';
import DE from '@/views/DE/Index.vue';

export const DERoutes = {
  path: 'digitalExperience',
  name: 'digitalExperience',
  component: DE,
  redirect: {
    name: 'DEoverview',
  },
  children: [
    {
      // This opens up the child components
      name: 'DEoverview',
      path: '',
      component: DEOverview,
    },
    {
      // This opens up the child components
      // TODO: This behaviour needs to be verified
      name: 'DEoverviewID',
      path: ':id',
      component: DEOverview,
    },
  ],
};
